import React from "react";
import { Card } from "react-bootstrap";
import CustomDropdown from "./CustomDropdown";
import "../../assets/css/icons.css";
import "../../assets/css/styles.css";

import { withNamespaces } from "react-i18next";

const CardEarningMonthly = ({ apagarWidget, ...props }) => {
  const { t } = props;
  return (
    <div className="main-card-v2">
      <Card bsPrefix="card-flat">
        <Card.Header className="justify-content-between">
          <h6>
            <i className="icon-bell mr-2" /> {t("CardEarningMonthly.title")}
          </h6>
          <CustomDropdown apagarWidget={apagarWidget} />
        </Card.Header>
        <Card.Body>
          <Card.Text>$40,000</Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
};
export default withNamespaces()(CardEarningMonthly);
